import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

import { FormControl, FormGroup } from "@angular/forms";
import { SelectMenuOption } from "../../../../form/select-menu/select-menu.component";
import { TranslationService } from "../../../../_services/translation.service";
import { ITranslations } from "../../../../_models/ITranslations";
import { Observable } from "rxjs/Observable";
import { GeneralRowEvent } from "../../../../_models/general-row-event";
import { DateRangeSelectComponent } from "../../../../common/date-range-select/date-range-select.component";
import { EventsService } from "../../../../_services/eventsServices/events.service";
import { DiscountManagementService } from "../../../../_services/discount-management.service";
import { environment } from "../../../../../environments/environment";
import { ChildAbstractModel } from "../../../../_models/child-abstract-model";
import { ServerNamespace } from "../../../../_models/server/server-namespace";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SelectOrgansComponent } from "../../../../common/select-organs/select-organs.component";
import { SelectLayersComponent } from "../../../../common/select-layers/select-layers.component";

@Component({
  selector: "discount-management-search",
  templateUrl: "./discount-management-search.component.html",

  styleUrls: [
    "./discount-management-search.component.scss",
    "../../../payments/payments.component.scss",
  ],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          height: "90px",
          maxHeight: "230px",
          overflow: "visible",
          opacity: 1,
        })
      ),
      state(
        "closed",
        style({
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class DiscountManagementSearchComponent {
  @ViewChild("componentMain") public componentMain: ElementRef;

  @ViewChild("selectOrgansComponent")
  public selectOrgansComponent: SelectOrgansComponent;

  @ViewChild("selectLayersComponent")
  public selectLayersComponent: SelectLayersComponent;
  @ViewChild("dateRangePicker")
  public dateRangePicker: DateRangeSelectComponent;
  @Output("searchSectionEvent") public searchSectionEvent: EventEmitter<
    GeneralRowEvent<any>
  > = new EventEmitter<GeneralRowEvent<any>>();

  public hideAdvancedSearch: boolean =
    environment.features.hideAdvanceSearchInDiscountManagement;

  public advanceSearchOpen: boolean = false;
  public advanceSearchForm = new FormGroup({
    limitToCurrentYear: new FormControl(true),
  });
  public yearsSelectMenuOptions: SelectMenuOption[] = [
    {
      icon: "",
      key: "thisYear",
      text: 'תשפ"ד',
      customValue: "",
    },
    {
      icon: "",
      key: "allYears",
      text: "כל השנים",
      customValue: "",
    },
  ];

  public translations$: Observable<ITranslations>;
  public selectedChild: ChildAbstractModel | null = null;
  private selectedEvent: string | null = null;

  constructor(
    private modalService: NgbModal,
    private eventsService: EventsService,
    private translationService: TranslationService,
    private discountManagementService: DiscountManagementService
  ) {
    this.getCurrentYear().then();
    this.translations$ = this.translationService.translations;
  }

  public get advancedSearchFeatureActive(): boolean {
    return true;
  }

  public async getCurrentYear() {
    const shnatPeilut = await this.eventsService.getCurrentYear();
    if (shnatPeilut) {
      this.yearsSelectMenuOptions = this.yearsSelectMenuOptions.map((year) => {
        if (year.key === "thisYear") {
          return { ...year, text: shnatPeilut.value };
        }
        return year;
      });
    }
  }

  public openAdvanced() {
    this.advanceSearchOpen = !this.advanceSearchOpen;
  }

  public submitAdvancedSearch() {
    const selectedNests = this.selectOrgansComponent.getSelectedOrgans() || [];
    const grades_ids = this.selectLayersComponent.getSelectedLayers() || [];

    const limitToCurrentYear = this.advanceSearchForm.value.limitToCurrentYear;

    const kehilot = selectedNests
      .filter((k) => k.type === "circle")
      .map((k) => +k.id);
    const kenim = selectedNests
      .filter((k) => k.type === "nest")
      .map((k) => +k.id);
    const mehozot = selectedNests
      .filter((c) => c.type === "county")
      .map((k) => +k.id);
    const hanich_id =
      this.selectedChild && this.selectedChild.childId
        ? this.selectedChild.childId.toString()
        : null;
    const parent_event_id = this.selectedEvent;

    this.discountManagementService
      .searchDiscounts({
        limitToCurrentYear,
        kehilot,
        kenim,
        mehozot,
        hanich_id,
        parent_event_id,
        grades_ids,
      } as any)
      .then();
  }

  public childSelectedEvent($event: ChildAbstractModel | null) {
    this.selectedChild = $event;
  }

  public eventSelectedEvent(
    $event: ServerNamespace.GetParentEventForSubsidySearch | null
  ) {
    this.selectedEvent = $event && $event.id.toString();
  }

  public async exportToExcel() {
    await this.discountManagementService.exportToExcel();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/discount-management-page/discount-management-search/discount-management-search.component.ts